import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';
import CloseIcon from '../CloseIcon';
import { BODY_TEXT_COLOR, THIRD_COLOR } from '../../config/colors'
import { HeaderDiv } from '../../modals';

const styles = {
  closeIcon: { "position":"absolute",top:0,"right":"0","margin":"8px 5px 0 0" },
  labelStyle: {fontWeight:700}
};

class SignUpErrorModal extends Component {
    isNextBtnClicked: false;
    modalStyle = { border: '3px solid #' + this.props.secondaryColor };

    componentWillMount() {
      if (!this.props.isSuccess) return;
      setTimeout(() => {
          this.onCloseRequest();
      }, 1000)
    }

    onCloseRequest = () => {
      if (this.isNextBtnClicked) return;
        this.props.hideModal();
    }
    handleTryClick = () => {
        this.isNextBtnClicked = true;
        this.props.openSignUpForm(this.props.signUpFormValues);
    }
 
  render() {
    return (
      <Modal 
        style={this.modalStyle} 
        overlayTop={0} 
        paddingTop={100} 
        closeOnOutsideClick={true} 
        isOpened={true}
        onClose={this.onCloseRequest}>
        <ModalWrapperDiv>
            <div onClick={this.onCloseRequest} style={styles.closeIcon}><CloseIcon style={{height:'35px', width:'35px', color: THIRD_COLOR}} /></div> 
            <HeaderDiv color={BODY_TEXT_COLOR}>{this.props.errorMessage}</HeaderDiv> 
           
              <ButtonsWrapperDiv>
                 <RaisedButton
                    onClick={this.handleTryClick}
                    backgroundColor={`#` + this.props.secondaryColor}
                    labelColor="#FFF"
                    label="Try Again"
                    labelStyle={styles.labelStyle}
                  />
              </ButtonsWrapperDiv>
        </ModalWrapperDiv>
       </Modal>
    );
  }
}


SignUpErrorModal.propTypes = {
  signUpFormValues: PropTypes.objectOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = (state) => {
  return {
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
      hideModal: () => dispatch(modal.hideModal()),
      openSignUpForm: (signUpFormValues) => dispatch(modal.openModal({
        modalType: 'SIGNUP_FORM',
        modalProps: {signUpFormValues}
      })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpErrorModal);

const ModalWrapperDiv = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: 100%;
    font-family: 'Futura-Bold',  sans-serif;
`;


const ButtonsWrapperDiv = styled.div `
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
`;




// WEBPACK FOOTER //
// ./src/components/SignUpErrorModal/SignUpErrorModal.jsx